import React, { AllHTMLAttributes, FC, useContext } from 'react';

import { cn } from '../../../../../../utils';
import { ChevronIcon } from '../../../../icons';
import { ModalContext } from '../../ModalContext';

import './ModalClose.scoped.scss';

interface Props extends AllHTMLAttributes<HTMLDivElement> {}

const ModalClose: FC<Props> = ({ ...props }) => {
  const context = useContext(ModalContext);
  const handleClick = () => {
    context.onClose();
  };
  return (
    <div {...props} onClick={handleClick} className={cn('my-modal-close', props.className)}>
      <ChevronIcon direction="left" color="var(--white-color)" />
    </div>
  );
};

export default ModalClose;
